module.exports = __webpack_public_path__ + "static2023-4-17/img/red-pack.f9720a98.png";